module.exports = __webpack_public_path__ + "static/ogimage-7c9e7e3daeede846ee45b794af4485fc.jpg";